import React from 'react'

import { ToggleRadioButtonGroup } from '~/components/elements/ToggleRadioButtonGroup'
import { type RoleName } from '~/gql/graphql'

import { type UserRoleTypesAttribute } from '../types'

type UserRoleTypeSelectorProps = {
  attributes: UserRoleTypesAttribute[]
  onChange: (value: RoleName) => void
  value: RoleName
}

export const UserRoleTypeSelector = ({
  attributes,
  onChange,
  value,
}: UserRoleTypeSelectorProps) => (
  <ToggleRadioButtonGroup
    attributes={attributes}
    value={value}
    onChange={onChange}
  />
)
